<template>
  <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
    <CModal
      :closeOnBackdrop="false"
      :show.sync="modal"
      :no-close-on-backdrop="false"
      :centered="true"
      title=""
      size="lg"
      color="dark"
    >
      <CCard>
        <CCardBody>
          <CAlert
            v-if="alertMsg"
            :color="alertClr"
            closeButton
            fade
          >
            {{ alertMsg }}
          </CAlert>
          <CForm>
            <ValidationProvider
              :rules="`required|max:${constdata.POSITION_NAME_MAX_LEN}`"
              v-slot="{ errors }"
              name="役職名"
            >
              <CInput
                label="役職名*"
                v-model="inputItems.position_name"
                horizontal
              />
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              :rules="`required|between:${constdata.POSITION_NUMBER_MIN_VAL},${constdata.POSITION_NUMBER_MAX_VAL}`"
              v-slot="{ errors }"
              name="役職優位番号"
            >
              <CInput
                label="役職優位番号*"
                v-model.number="inputItems.position_number"
                type="number"
                horizontal
              />
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </CForm>
        </CCardBody>
      </CCard>
      <template #header>
        <h6 class="modal-title" ref="modal-title">役職マスタ登録</h6>
        <CButtonClose @click="closeModal" class="text-white" />
      </template>
      <template #footer>
        <CButton
          @click="alertValidation(handleSubmit(register))"
          color="success"
          >登録</CButton
        >
      </template>
    </CModal>
  </ValidationObserver>
</template>

<script>
import constdata from "../../../../definition/const/const_position.js";
import constMsg from "../../../../definition/const/const_message.js";
export default {
  name: "PositionAddModal",
  data() {
    return {
      inputItems: {
        position_number: "",
        position_name: "",
      },
      modal: false,
      alertMsg: "",
      alertClr: "",
      constdata: constdata,
      authorities: [],
    };
  },
  watch: {
    visible: {
      handler: function () {
        this.modal = this.visible;
      },
    },
  },
  props: {
    visible: {
      type: Boolean, // Boolean型に限定
      required: true, // 必須項目
    },
  },
  index: {
    type: Number,
  },
  async mounted() {
    // 初期データ取得
    await this.fetchData();
  },
  methods: {
    closeModal() {
      // 入力項目初期化
      Object.assign(this.$data.inputItems, this.$options.data().inputItems);
      // 初期化時に発生するバリデーションエラーをリセット
      this.$refs.observer.reset();
      // バリデーションエラーのメッセージを非表示
      this.alertMsg = "";
      // クローズ処理
      this.modal = false;
      this.$emit("close");
    },
    alertValidation() {
      // バリデーションエラーがあればエラーメッセージを表示
      this.$refs.observer.validate().then((success) => {
        if (!success) {
          // モーダルを閉じずにバリデーションエラーメッセージを表示
          this.alertClr = "danger";
          this.alertMsg =
            "入力内容に不備があります。詳細は各項目を確認してください。";
          // モーダルトップへスクロール
          this.$refs["modal-title"].scrollIntoView({
            behavior: "smooth",
            block: "end",
          });
        }
      });
    },
    async register() {
      var param = this.inputItems;
      // ログインユーザーIDをパラメーターに含める
      param.login_user_id = this.$store.state.loginUser.user_id;
      // 登録処理
      const ret = await this.createPositions(param);
      // 入力項目初期化
      Object.assign(this.$data.inputItems, this.$options.data().inputItems);
      // 初期化時に発生するバリデーションエラーをリセット
      this.$refs.observer.reset();
      // バリデーションエラーのメッセージを非表示
      this.alertMsg = "";
      // クローズ処理
      this.modal = false;
      this.$emit("close", ret);
    },
    async createPositions(param) {
      let ret = {};
      await this.$axios
        .post("/api/v1/positions", param)
        .then((res) => {
          ret.alertClr = "success";
          ret.alertMsg = constMsg.I0002_JP;
        })
        .catch((e) => {
          ret.alertClr = "danger";
          ret.alertMsg = e.response.data.message;
        });
      return ret;
    },
    async fetchData() {
      // 閲覧権限初期値リストデータセット
      this.authorities = await this.getAuthorityList();
    },
    async getAuthorityList() {
      let ret = null;
      await this.$axios
        .get("/api/v1/authorities")
        .then((res) => {
          ret = res.data.authorities;
        })
        .catch((e) => {
          console.error(e.response.data.message);
        });
      return ret;
    },
  },
};
</script>